<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar title="Assignment" :icon="require('@/assets/admin-icon/assignment-active.svg')">
        <div class="options">
          <widgetButton :loading="false" @click="showAddUpdateForm()" class="btn-primary">
            Add Assignment
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>

    <div class="page-body">
      <div class="company-profile-wrapper">
        <!-- company-profile display -->
        <div class="company-profile-container">
          <div class="assignment-widget">
            <multipane class="custom-resizer" layout="vertical">
              <div class="left-panel">
                <div class="left-panel-header">
                  All assignments
                </div>
                <div class="left-panel-body" v-if="leads.length > 0">
                  <assignmentItem v-for="(item, i) in leads" :key="i" :item="item" @onAssign="assingConsultant(item)" />
                </div>

                <div class="left-panel-body" v-else>
                  <widgetNotFoundWidget title="No public assignment found"
                    content="Looks like no public assignment found">
                    <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
                  </widgetNotFoundWidget>
                </div>
              </div>
              <multipane-resizer></multipane-resizer>
              <div class="right-panel">
                <div class="right-panel-header">
                  <widgetTabs :tabs="[
                    {
                      title: 'Assigned',
                      value: 'assigned',
                    },
                    {
                      title: 'Our assignment',
                      value: 'our_assignment',
                    },
                  ]" v-model="activeTab" @change="onTabChanged"></widgetTabs>
                </div>
                <div v-if="activeTab == 1 && user.assignment_assigned.length > 0" class="right-panel-body">
                  <assignmentItem v-for="(item, i) in user.assignment_assigned" :key="i" :item="item" type="assigned" />
                </div>
                <div v-if="activeTab == 1 && user.assignment_assigned.length == 0" class="right-panel-body">
                  <widgetNotFoundWidget title="No assignment found" content="Looks like no  assignment found">
                    <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
                  </widgetNotFoundWidget>
                </div>

                <div v-if="activeTab == 2 && our_assignment.length > 0" class="right-panel-body">
                  <assignmentItem v-for="(item, i) in our_assignment" :key="i" :item="item"
                    @onAssign="assingConsultant(item)" @onPublish="publish(item.id)" @onUnpublish="unpublish(item.id)"
                    @onEdit="editAssignment(item)" @onDelete="deleteAssingment(item, i)" type="our" />
                </div>

                <div v-if="activeTab == 2 && our_assignment.length == 0" class="right-panel-body">
                  <widgetNotFoundWidget title="No assignment found" content="Looks like no assignment found"
                    btntext="Add Assingment" @click="showAddUpdateForm()">
                    <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
                  </widgetNotFoundWidget>
                </div>



              </div>
            </multipane>
          </div>
        </div>
        <!-- End -->
      </div>
    </div>

    <!-- Add and Update form -->
    <add-assignment v-if="add_assignment_modal" @onClose="showList()" :value="assignment_selected_item"
      :company_id="user.company_info.id" @onFinish="afterAssignementAdded()" />

    <!-- Select consultant -->
    <div class="select-consultant-wrapper" v-if="show_select_consultants">
      <selectConsultants :value="assignment_selected_item" @onClose="show_select_consultants = false" />
    </div>

  </div>
</template>

<script>
import { eventBus } from "@/main";
import lottie from "lottie-web";
import * as animationData from "@/assets/json/loader";
import addAssignment from "./components/addAssignment.vue";
import selectConsultants from "./components/selectConsultants.vue";
import assignmentItem from "./components/assignmentItem.vue"
export default {
  name: "Assignment",
  components: {
    addAssignment,
    selectConsultants,
    assignmentItem
  },
  props: {},
  data: () => {
    return {
      activeTab: 1,
      tab: "assing",
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
        projects: [],
        assignment_assigned: [],
      },
      leads: [],
      add_assignment_modal: false,
      assignment_selected_item: null,
      search_assignment: "",
      showLoading: false,
      anim: null,
      show_list: true,
      show_select_consultants: false,
      our_assignment: [],
    };
  },
  mounted() {
    let vm = this;
    vm.anim = lottie.loadAnimation({
      container: vm.$refs.loader,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData.default,
    });
    vm.getAssignment();
    vm.getAllStartData();
    vm.getOurAssingment();
  },
  computed: {},
  methods: {
    onTabChanged(tab) { },
    assingConsultant(item) {
      let vm = this;
      vm.show_select_consultants = true;
      vm.assignment_selected_item = item;
    },
    getOurAssingment() {
      let vm = this;
      vm.$store
        .dispatch("GET_ASSIGNMENT")
        .then((responce) => {
          vm.our_assignment = responce.data.map((item) => {
            let roles = item.role;
            let skills = [];
            let loc = "";
            if (item.user) {
              if (item.user.customer_profile)
                eventBus.$set(
                  item,
                  "customer",
                  item.user.customer_profile.name
                );
              else eventBus.$set(item, "customer", item.user.username);
            } else eventBus.$set(item, "customer", "");

            eventBus.$set(item, "skills_data", item.skills);
            eventBus.$set(item, "address", item.address);
            eventBus.$set(item, "view_more", false);
            eventBus.$set(item, "more_skills", false);

            item.skills.forEach((skill) => {
              skill.roles.forEach((i) => {
                skills.push(i.name);
              });
              skill.tools.forEach((i) => {
                skills.push(i.name);
              });
              skill.domains.forEach((i) => {
                skills.push(i.name);
              });
              skill.competences.forEach((i) => {
                skills.push(i.name);
              });
              skill.languages.forEach((i) => {
                skills.push(i.name);
              });
            });
            item.roles = roles;
            eventBus.$set(item, "all_skills", skills);
            eventBus.$set(item, "less_skills", skills.slice(0, 3));
            item.skills = item.less_skills;

            return item;
          });
        })
        .catch((error) => { });
    },
    getAllStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;
          vm.user.assignment_assigned = vm.user.assignment_assigned.map(
            (item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);
              eventBus.$set(item, "view_more", false);
              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              eventBus.$set(item, "all_skills", skills);
              eventBus.$set(item, "less_skills", skills.slice(0, 3));
              item.skills = item.less_skills;
              return item;
            }
          );
        })
        .catch((error) => { });
    },
    showAddUpdateForm() {
      let vm = this;
      vm.add_assignment_modal = true;
      vm.assignment_selected_item = {};
      vm.show_list = true;
    },
    showList() {
      let vm = this;
      vm.add_assignment_modal = false;
      vm.show_list = true;
    },
    afterAssignementAdded() {
      let vm = this;
      vm.activeTab = 2;
      vm.showList();
      vm.getAssignment();
      vm.getAllStartData();
      vm.getOurAssingment();
    },
    getAssignment() {
      let vm = this;
      vm.showLoading = true;
      vm.$store
        .dispatch("GET_ALL_ASSIGNMENT")
        .then((value) => {
          vm.showLoading = false;
          vm.leads = value.data.data.map((item) => {
            let roles = item.role;
            let skills = [];
            let loc = "";
            if (item.user) {
              if (item.user.customer_profile)
                eventBus.$set(
                  item,
                  "customer",
                  item.user.customer_profile.name
                );
              else eventBus.$set(item, "customer", item.user.username);
            } else eventBus.$set(item, "customer", "");

            eventBus.$set(item, "address", item.address);
            eventBus.$set(item, "view_more", false);
            eventBus.$set(item, "more_skills", false);

            item.skills.forEach((skill) => {
              skill.roles.forEach((i) => {
                skills.push(i.name);
              });
              skill.tools.forEach((i) => {
                skills.push(i.name);
              });
              skill.domains.forEach((i) => {
                skills.push(i.name);
              });
              skill.competences.forEach((i) => {
                skills.push(i.name);
              });
              skill.languages.forEach((i) => {
                skills.push(i.name);
              });
            });
            item.roles = roles;
            eventBus.$set(item, "all_skills", skills);
            eventBus.$set(item, "less_skills", skills.slice(0, 3));
            item.skills = item.less_skills;

            return item;
          });
        })
        .catch((reason) => {
          vm.showLoading = false;
          console.log(reason);
        });
    },
    searchAssignment(string) {
      let vm = this;
      vm.showLoading = true;
      if (vm.tab == "all") {
        vm.$store
          .dispatch("SEARCH_ASSIGNMENT", { query: string })
          .then((value) => {
            vm.showLoading = false;
            vm.leads = value.data.map((item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);
              eventBus.$set(item, "view_more", false);
              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              item.skills = skills;

              return item;
            });
          })
          .catch((error) => {
            vm.showLoading = false;
            console.error({ error });
          });
      } else if (vm.tab == "assing") {
        vm.$store
          .dispatch("SEARCH_ASIGNED_ASSIGNMENT", { query: string })
          .then((value) => {
            vm.showLoading = false;
            vm.user.assignment_assigned = value.data.map((item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);
              eventBus.$set(item, "view_more", false);
              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              item.skills = skills;

              return item;
            });
          })
          .catch((error) => {
            vm.showLoading = false;
            console.error({ error });
          });
      }
    },
    deleteAssingment(item, i) {
      let vm = this;
      vm.$store
        .dispatch("DELETE_ASSIGNMENT", { id: item.id })
        .then((response) => {
          vm.our_assignment.splice(i, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editAssignment(item) {
      let vm = this;
      vm.assignment_selected_item = null;
      vm.add_assignment_modal = true;
      vm.assignment_selected_item = item;
      vm.show_list = true;
    },
    unpublish(id) {
      let vm = this;
      vm.$store
        .dispatch("UNPUBLISH_ASSIGNMENT", { id: id })
        .then((response) => {
          vm.getAssignment();
          vm.getAllStartData();
          vm.getOurAssingment();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    publish(id) {
      let vm = this;
      vm.$store
        .dispatch("PUBLISH_ASSIGNMENT", { id: id })
        .then((response) => {
          vm.getAssignment();
          vm.getAllStartData();
          vm.getOurAssingment();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    search_assignment: function (val) {
      if (val != "") {
        this.searchAssignment(val);
      } else {
        this.getAssignment();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
        height: 45px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .page-body {
    height: calc(100% - 60px);
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .company-profile-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      .company-profile-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .assignment-widget {
          height: 100%;
          width: 100%;
          position: relative;
          display: flex;
          flex-direction: column;

          .custom-resizer {
            height: 100%;

            .multipane-resizer {
              width: 10px !important;

              &::before {
                top: 0px !important;
                height: calc(100% - 20px) !important;
              }
            }
          }

          .left-panel {
            height: 100%;
            width: 50%;
            min-width: 40%;
            max-width: 50%;
            border-radius: 5px;
            display: flex;
            flex-direction: column;

            .left-panel-header {
              height: 50px;
              width: 100%;
              display: flex;
              align-items: center;
              background: #fff;
              border-radius: 5px;
              padding: 0px 20px;
              margin-bottom: 10px;
            }

            .left-panel-body {
              height: calc(100% - 60px);
              width: 100%;
              display: flex;
              flex-direction: column;
              overflow-y: auto;
            }
          }

          .right-panel {
            height: 100%;
            min-width: 40%;
            width: 50%;
            border-radius: 5px;
            display: flex;
            flex-grow: 1;
            flex-direction: column;

            .right-panel-header {
              height: 50px;
              width: 100%;
              display: flex;
              align-items: center;
              padding: 0px 20px;
              margin-bottom: 10px;
              background: #fff;
              border-radius: 5px;
            }

            .right-panel-body {
              height: calc(100% - 60px);
              width: 100%;
              display: flex;
              flex-direction: column;
              overflow-y: auto;
            }
          }

          .internship-widget {
            display: flex;
            flex-direction: column;
            height: 100%;


          }
        }
      }
    }
  }
}
</style>